module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_David_CR-fea5c6660f5fa73c6ac0a9cb46709630.jpg";